import { useEffect, useRef, useState } from 'react'

import SetState from 'Components/Hooks/SetState'
import Search from 'Components/UI/Atoms/Search'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import ListWithIcon from 'Components/UI/Molecules/Lists/ListWithIcon'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import PaperList from 'Components/UI/Molecules/Papers/PaperList'
import { useSnackbar } from 'notistack'
import { interfaces } from 'service/interfaces'

import UpdateForm from './Update'

const WafersContent = () => {
  const [concepts, setConcepts] = useState([])
  const [valueSearch, setValueSearch] = useState('')
  const [selectedConcept, setSelectedConcept] = useState(null)
  const [render, setRender] = useState(false)
  const { enqueueSnackbar } = useSnackbar()
  const [tipoOblea, setTipoOblea] = useState()

  const { state: editConcept, setOpen: setOpenEdit, setClose: setCloseEdit } = SetState()

  const formSubmitRef = useRef(null)

  const getConcepts = async () => {
    await interfaces.configInterface.listWafers().then((res) => {
      setConcepts(res.data.wafers)
      setTipoOblea(res.data.OBLEA_TIPO)
    })
  }

  const onUpdateConcept = async (data) => {
    const id = selectedConcept?.id

    let obleaTipoId = data.oblea_tipo
    if (typeof data.oblea_tipo === 'string') {
      const encontrado = tipoOblea.find((t) => t.tipo === data.oblea_tipo)
      if (encontrado) {
        obleaTipoId = encontrado.id
      }
    }
    const oblea = { oblea_tipo: obleaTipoId }
    await interfaces.configInterface
      .updateWafers(id, oblea)
      .then((res) => {
        setRender(!render)
        setCloseEdit()
        setSelectedConcept(null)
        enqueueSnackbar(res.data, { variant: 'success' })
      })
      .catch((err) => {
        enqueueSnackbar(err.response.data, {
          variant: 'error',
        })
      })
  }

  const onChangeSearch = (e) => {
    setValueSearch(e.target.value.toLowerCase())
  }

  const search = (data) => {
    return data
      .filter((wafer) => {
        return wafer.oblea_rudac.toLowerCase().includes(valueSearch)
      })
      .sort((a, b) => a.oblea_rudac.localeCompare(b.oblea_rudac, 'es', { sensitivity: 'base' }))
  }

  const onClickItem = (item) => {
    setSelectedConcept(item)
  }

  const handleSubmit = () => {
    formSubmitRef.current.click()
  }

  useEffect(() => {
    getConcepts()
  }, [render])

  return (
    <>
      <Search onChange={onChangeSearch} placeholder="Buscar" />
      <PaperList
        children={
          <ListWithIcon
            data={search(concepts)}
            nameIncludes="oblea_rudac"
            selectedItem={selectedConcept?.id}
            onClickSelect={onClickItem}
            onClickEdit={setOpenEdit}
          />
        }
        height="500px"
        styles={{ marginBottom: '15px' }}
      />

      {editConcept.suspense && (
        <DialogComponent
          disableBackdropClick
          disableEscapeKeyDown
          widthLarge="25vw"
          title="Editar oblea"
          open={editConcept.open}
          handleclose={setCloseEdit}
          children={
            <UpdateForm
              onSubmit={onUpdateConcept}
              formRef={formSubmitRef}
              concept={selectedConcept}
              tipoOblea={tipoOblea}
              setSelectedConcept={setSelectedConcept}
            />
          }
          actions={
            <CancelConfirmButtons
              onClickSubmit={handleSubmit}
              onClickCancel={setCloseEdit}
              disabledSubmit={selectedConcept?.oblea_tipo ? false : true}
            />
          }
          maxHeight
        />
      )}
    </>
  )
}

export default WafersContent
